interface Props {
  children: React.ReactNode;
}

export default function TableCell({ children }: Props) {
  return <div className="flex-1 truncate">{children}</div>;
}
